<div id="accordion">
    <mat-nav-list class="main-menu">
        <mat-list-item [routerLink]="['/home']" data-toggle="collapse" data-target="#collapseHome" aria-expanded="true"
                       aria-controls="collapseHome">
            <button mat-icon-button>
                <mat-icon>home</mat-icon>
            </button>
            <span class="menu-title">Overview</span>
        </mat-list-item>
    </mat-nav-list>
    <div id="collapseHome" class="sub-menu collapse" aria-labelledby="headingOne" data-parent="#accordion"></div>
    <mat-nav-list class="main-menu">
        <mat-list-item data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                       aria-controls="collapseOne">
            <button mat-icon-button>
                <mat-icon>collections</mat-icon>
            </button>
            <span class="menu-title">Manage Products</span>
        </mat-list-item>
    </mat-nav-list>
    <div id="collapseOne" class="sub-menu collapse" aria-labelledby="headingOne" data-parent="#accordion">
        <mat-nav-list>
            <mat-list-item [routerLink]="['/products']" routerLinkActive="active"
                           [routerLinkActiveOptions]="{exact:true}">
                <span class="menu-title">Product List</span>
            </mat-list-item>
            <mat-list-item>
                <span class="menu-title">Product Category</span>
            </mat-list-item>
        </mat-nav-list>
    </div>
    <mat-nav-list class="main-menu">
        <mat-list-item data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                       aria-controls="collapseTwo">
            <button mat-icon-button>
                <mat-icon>category</mat-icon>
            </button>
            <span class="menu-title">Manage Categories</span>
        </mat-list-item>
    </mat-nav-list>
    <div id="collapseTwo" class="sub-menu collapse" aria-labelledby="headingTwo" data-parent="#accordion">
        <mat-nav-list>
            <mat-list-item>
                <span class="menu-title">Category List</span>
            </mat-list-item>
            <mat-list-item>
                <span class="menu-title">Category View</span>
            </mat-list-item>
        </mat-nav-list>
    </div>
    <mat-nav-list class="main-menu">
        <mat-list-item data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                       aria-controls="collapseThree">
            <button mat-icon-button>
                <mat-icon>monetization_on</mat-icon>
            </button>
            <span class="menu-title">Manage Prices</span>
        </mat-list-item>
    </mat-nav-list>
    <div id="collapseThree" class="sub-menu collapse" aria-labelledby="headingThree" data-parent="#accordion">
        <mat-nav-list>
            <mat-list-item>
                <span class="menu-title">Price List</span>
            </mat-list-item>
            <mat-list-item>
                <span class="menu-title">Price View</span>
            </mat-list-item>
        </mat-nav-list>
    </div>
    <mat-nav-list class="main-menu">
        <mat-list-item data-toggle="collapse" data-target="#collapseFour" aria-expanded="false"
                       aria-controls="collapseThree">
            <button mat-icon-button>
                <mat-icon>flight</mat-icon>
            </button>
            <span class="menu-title">Manage Regional</span>
        </mat-list-item>
    </mat-nav-list>
    <div id="collapseFour" class="sub-menu collapse" aria-labelledby="headingFour" data-parent="#accordion">
        <mat-nav-list>
            <mat-list-item [routerLink]="['/regional', 'country']" >
                <span class="menu-title">Manage Countries</span>
            </mat-list-item>
            <mat-list-item [routerLink]="['/regional', 'courier']" >
                <span class="menu-title">Manage Couriers</span>
            </mat-list-item>
            <mat-list-item [routerLink]="['/regional', 'states']" >
                <span class="menu-title">Manage States</span>
            </mat-list-item>
            <mat-list-item [routerLink]="['/regional', 'zones']" >
                <span class="menu-title">Manage Zones</span>
            </mat-list-item>
            <mat-list-item [routerLink]="['/regional', 'cities']" >
                <span class="menu-title">Manage Cities</span>
            </mat-list-item>
        </mat-nav-list>
    </div>
</div>
